import { AppStore } from '../Redux';
import { addActivityStatusSub, callActivityWakeUp } from '../Redux/ActivityStatusActions';
import { HEARTBEAT_INTERVAL } from '../Utils/time';

let appStore: AppStore | null = null;
let lastUserActivityTime = Date.now();

export const injectGlobalObserverStore = (store: AppStore) => {
  appStore = store;
};

export const getLastUserActivityTime = () => lastUserActivityTime;

// NOTE: We use IntersectionObserver to only call ADD_ACTIVITY_STATUS_SUB Saga
//     : for the user whose UserStatusDotWrapper is rendered on screen (not entire DOM).
//     : We cannot use the useEffect inside UserStatusDotWrapper to dispatch since
//     : it would rapidly call ADD_ACTIVITY_STATUS_SUB Sagas on initial render
//     : and potentially the Sagas got backlogged (or the socket disconnects sometimes)
export const userPresenceObserver = new IntersectionObserver((entries) => {
  if (!appStore) return;

  entries.forEach((entry) => {
    if (!appStore) return;

    // Scrolling off-screen -> keep the subscription
    if (!entry.isIntersecting) return;

    // Each user avatar is tagged with data-userid with userId as value
    const dataUserId = entry.target.getAttribute('data-userid');

    // Don't subscribe when the Avatar attribute is invalid
    if (!dataUserId || isNaN(parseInt(dataUserId))) return;

    const userId = Number(dataUserId);

    const subscribedUsers = appStore.getState().activityStatuses.activityStatuses;

    // Scrolling into screen -> add to subscription set if not store in Redux yet
    if (!subscribedUsers[userId]) {
      appStore.dispatch(addActivityStatusSub(userId));
    }
  });
});

if (typeof window !== 'undefined') {
  const updatedActivity = () => {
    const now = Date.now();

    const timeSinceLastActivity = now - lastUserActivityTime;

    // If the user just being active after missing the next status heartbeat checkout OR currently inactive,
    // then send the Saga wake up command immediately to update to active status
    if (appStore) {
      const userId = appStore.getState().auth.profile?.userId;

      if (userId) {
        const status = appStore.getState().activityStatuses.activityStatuses[userId];

        // There is a case where the user does not subscribe to their own status;
        // thus, would rely on the 5-min inactiveness to send the wake-up instead
        // of checking the Redux store for inactive status (since Redux hasn't store it yet)
        if (timeSinceLastActivity > HEARTBEAT_INTERVAL || status === 'inactive') {
          appStore.dispatch(callActivityWakeUp(userId));
        }
      }
    }

    // Update the user current activity timestamp
    lastUserActivityTime = Date.now();
  };

  // If user movement is detected, wait for 1 sec then check-in the heartbeat
  let userActivityDetectedTimer: NodeJS.Timeout | null = null;
  const userActivityDetectedUpdate = () => {
    if (userActivityDetectedTimer) return;

    userActivityDetectedTimer = setTimeout(() => {
      updatedActivity();
      userActivityDetectedTimer = null;
    }, 1000);
  };

  // All kind of user movements that determine user is active
  window.addEventListener('mousemove', userActivityDetectedUpdate, { passive: true });
  window.addEventListener('keydown', userActivityDetectedUpdate, { passive: true });
  window.addEventListener('click', userActivityDetectedUpdate, { passive: true });
}
